export enum PluginStatus {
  Waiting = 0,
  Booted = 1,
  BootFailed = 2,
  ResourceLoadingFailed = 3,
  Booting = 4
}
